/// <amd-module name="Core/Medius.Core.Web/Scripts/Helpers/windowWrapper"/>
// due to changes introduced in Jest v30 window.location and window.location.replace() became readonly and it made testing usages of this function difficult. 
// 'redirectTo' was created to enable mocking
export function redirectTo(url: string) {
  window.location.replace(url);
}